import { useEffect } from "react";

const useMetaTags = ({
  title,
  description,
  keywords,
  author,
  robots,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType = "website",
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage,
  twitterSite,
  twitterCreator,
}) => {
  useEffect(() => {
    document.title = title;

    const metaTags = [
      { name: "description", content: description },
      { name: "keywords", content: keywords },
      { name: "author", content: author },
      { name: "robots", content: robots },
      { name: "canonical", content: canonical },
      { property: "og:title", content: ogTitle || title },
      { property: "og:description", content: ogDescription || description },
      { property: "og:image", content: ogImage },
      { property: "og:url", content: ogUrl },
      { property: "og:type", content: ogType },
      { name: "twitter:card", content: twitterCard },
      { name: "twitter:title", content: twitterTitle || title },
      { name: "twitter:description", content: twitterDescription || description },
      { name: "twitter:image", content: twitterImage || ogImage },
      { name: "twitter:site", content: twitterSite },
      { name: "twitter:creator", content: twitterCreator },
    ];

    metaTags.forEach(({ name, property, content }) => {
      if (!content) return; // Skip empty values
      let tag = document.querySelector(name ? `meta[name="${name}"]` : `meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        if (name) tag.name = name;
        if (property) tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });

    return () => {
      metaTags.forEach(({ name, property }) => {
        const tag = document.querySelector(name ? `meta[name="${name}"]` : `meta[property="${property}"]`);
        if (tag) document.head.removeChild(tag);
      });
    };
  }, [
    title,
    description,
    keywords,
    author,
    robots,
    canonical,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    ogType,
    twitterCard,
    twitterTitle,
    twitterDescription,
    twitterImage,
    twitterSite,
    twitterCreator,
  ]);
};

export default useMetaTags;
